import { render, staticRenderFns } from "./StatusChangeDialog.vue?vue&type=template&id=fdc0e208"
import script from "./StatusChangeDialog.vue?vue&type=script&lang=js"
export * from "./StatusChangeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports